<script setup>
import { MultipleLookupConfig } from '@pfsc/core/models/multiple-lookup-config';
import { Package } from '@pfsc/core/models/package';
import { packageListMixins } from '@pfsc/core/ui-services/package-list.mixins';
import { globalTranslate } from '@pfsc/shared/locale/app.i18n';
import MultipleLookup from './multiple-lookup.vue';

const { getPackageList } = packageListMixins();

const props = defineProps({
  modelValue: {
    type: Array,
    required: true,
  },
  packageTypes: {
    type: Array,
    default: () => [],
  },
});

const emits = defineEmits(['update:model-value']);

const config = new MultipleLookupConfig({
  title: globalTranslate('lookup.package'),
  fetch: () => getPackageList(props.packageTypes),
  toReadable: Package.toDetailReadable,
});

</script>
<template>
  <multiple-lookup
    :model-value="modelValue"
    :config="config"
    @update:model-value="emits('update:model-value', $event)"
  />
</template>
